module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.isFullLoading),
      expression: "isFullLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "index"
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "banner-out-wrapper swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.pictures), function(pic) {
    return _c('a', {
      staticClass: "swiper-slide",
      style: ({
        backgroundImage: 'url(' + _vm.$store.state.UPLOAD_IMG_HOST + pic.picUrl + ')'
      }),
      attrs: {
        "href": ("" + (pic.linkUrl))
      },
      on: {
        "click": _vm.sendClickLog
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navigator-out-wrapper"
  }, [_c('div', {
    staticClass: "navigator-inner-wrapper"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'copyrighterIndex'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-copyright icon-80"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("我有好作品")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("————  我要找主播  ————")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-microphone icon-80"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("我有好声音")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("————  我要找作品  ————")])]), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-wrapper"
  }, [_c('div', {
    staticClass: "anchor-content-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("在这里的主播")]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.excellentAnchors), function(anchor) {
    return _c('a', {
      staticClass: "item",
      attrs: {
        "href": _vm.getAnchorLink(anchor),
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getUploadImg(anchor.logoPic)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "single-name"
    }, [_vm._v(_vm._s(anchor.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(anchor.nickname))]), _vm._v(" "), _c('span', {
      staticClass: "sub-title s-sub-title"
    }, [_vm._v(_vm._s(anchor.personalSignature || '无'))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_c('i', {
      staticClass: "icon icon-played"
    }), _vm._v(" "), (anchor.anchorStatCount && anchor.anchorStatCount.trackCount) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("formatNumber")(anchor.anchorStatCount.trackCount)) + "\n                            ")]) : _c('span', [_vm._v("0")]), _vm._v(" "), _c('i', {
      staticClass: "icon icon-fans"
    }), _vm._v(" "), (anchor.anchorStatCount && anchor.anchorStatCount.followCount) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm._f("formatNumber")(anchor.anchorStatCount.followCount)) + "\n                            ")]) : _c('span', [_vm._v("0")])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "author-wrapper"
  }, [_c('div', {
    staticClass: "author-content-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("已入驻的作家")]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('div', {
    staticClass: "item-first"
  }, [_c('img', {
    attrs: {
      "src": _vm.getUploadImg(_vm.authors[0].logoPic)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.authors[0].name))]), _vm._v(" "), _c('p', {
    staticClass: "big-desc"
  }, [_vm._v("\n                                " + _vm._s(_vm.authors[0].intro) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "item-left"
  }, _vm._l((_vm.authors), function(author, index) {
    return (index > 0) ? _c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": _vm.getUploadImg(author.logoPic)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(author.name))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": author.intro,
        "placement": "top",
        "popper-class": "desc-popper"
      }
    }, [_c('p', {
      staticClass: "desc"
    }, [_vm._v("\n                                    " + _vm._s(author.intro) + "\n                                ")])])], 1)]) : _vm._e()
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "cooperator-out-wrapper"
  }, [_c('div', {
    staticClass: "cooperator-inner-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("合作版权机构")]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.publishers), function(brandCover) {
    return _c('img', {
      attrs: {
        "src": _vm.getUploadImg(brandCover.logoPic)
      }
    })
  }))])]), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-slide banner"
  }, [_c('div', {
    staticClass: "banner-inner-wrapper"
  }, [_c('div', {
    staticClass: "large-slogan"
  }, [_c('p', [_vm._v("让你的作品有声")]), _vm._v(" "), _c('p', [_vm._v("这里·有4亿用户在听")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-slogan"
  }, [_c('span', [_c('span', {
    staticClass: "em"
  }, [_vm._v("3000")]), _vm._v(" 位专业主播为你讲述，"), _c('span', {
    staticClass: "em"
  }, [_vm._v("10万 ")]), _vm._v("部著作等你来读")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-item"
  }, [_c('i', {
    staticClass: "icon icon-post icon-80"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("我会后期")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("————  我要找后期工作  ————")]), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_vm._v("敬请期待")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1eb8b3a0!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Index.vue
// module id = 331
// module chunks = 0